import { useDispatch } from "react-redux";

import { convertToVariantCategories } from "./convertToVariantCategories";
import { getAnalyticsProviderItem } from "./getAnalyticsProviderItem";
import { getHandleAddToCart } from "./getHandleAddToCart";
import { useVariant } from "./useVariant";

import type { ticketState } from "../../../../modules/ticket";
import type { GoodsVenueSelector } from "components/event/goods/GoodsVenueSelector";
import type { ComponentProps, MouseEventHandler } from "react";

type Input = {
  eventId: string;
  classGoodsList: ticketState["eventGoods"];
  repGoods: ticketState["eventGoodsMap"][number];
  selectablePlaces: ComponentProps<typeof GoodsVenueSelector>["venues"];
  isAdmin: boolean;
  watchlistItemIds: Set<string>;
  handleClickWatch: (goodsId: string) => MouseEventHandler<HTMLButtonElement>;
};

export const useEventGoodsItemInfo = (input: Input) => {
  const { classGoodsList, eventId } = input;

  const variantCategories = convertToVariantCategories({
    variantList: classGoodsList,
  });
  const useVariantReturn = useVariant({ variantCategories });
  const { selectedVariantId, variantAmount } = useVariantReturn;
  const dispatch = useDispatch();
  const maybeSelectedGoods = classGoodsList.find(
    ({ subClass }) => subClass === selectedVariantId
  );
  const analyticsProviderItem = getAnalyticsProviderItem({
    eventId,
    maybeGoods: maybeSelectedGoods,
  });
  const handleAddToCart = getHandleAddToCart({
    dispatch,
    eventId,
    maybeSelectedGoods,
    variantAmount,
  });

  return {
    ...useVariantReturn,
    analyticsProviderItem,
    handleAddToCart,
    maybeId: maybeSelectedGoods?._id,
    variantCategories,
  };
};
